import { all, fork, takeLatest, put, select, call } from "redux-saga/effects";
import {
  GeneralActionTypes,
  SignalRTypes,
  BetSlipActionTypes,
  MembersActionTypes,
  AppActionTypes,
  SlotsActionTypes,
} from "../actions";
import { generalApi, membersApi, pagesApi } from "../../api";
import { SessionStorage, Cookies, AppConfig, Utils } from "../../helpers";
import { Env } from "../../helpers/enums";
import { Enums } from "../../helpers";
import React from "react";
const getGeneralImagesVersions = (list, name) => {
  let imageVersion = "";

  const foundItem = list.find((item) => item.imageName === name);

  if (foundItem) {
    imageVersion = `?id=${foundItem.imageVersion}`;
  }

  return imageVersion;
};
export function* requests() {
  yield takeLatest(GeneralActionTypes.Get_Currencies_Request, function*() {
    //call server
    try {
      let response = yield generalApi.getCurrencies();
      switch (response.status) {
        case 1:
          let data = response.data;
          let balances = data.reduce((acc, current) => {
            let currencyName = current.currencyName.split(" ").join("");
            if (!acc[currencyName]) {
              acc[currencyName] = {
                currencyId: current.currencyId,
                currencySymbol: current.currencySymbol,
                defaultCurrency: current.currencyIsDefault,
              };
            }
            return acc;
          }, {});
          let currency = Cookies.get("selectedCurrency");
          if (!currency) {
            let currentCurrency = Object.values(balances).find(
              (item) => item.defaultCurrency
            );
            yield put({
              type: MembersActionTypes.Set_Selected_Currency,
              currency: currentCurrency,
            });
            Cookies.set("selectedCurrency", currentCurrency);
          } else {
            yield put({
              type: MembersActionTypes.Set_Selected_Currency,
              currency: currency,
            });
          }
          yield put({
            type: GeneralActionTypes.Get_Currencies_Success,
            data: balances,
          });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Currencies_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get currencies: ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Map_Request, function*(mapData) {
    //call server
    try {
      let response = yield generalApi.mapMarkers(mapData.data);
      let data = response.data;

      switch (response.status) {
        case 1:
          yield put({ type: GeneralActionTypes.Map_Success, data });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Map_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get map: ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Form_Statuses_Request, function*({
    status,
  }) {
    //call server
    try {
      let response = yield generalApi.FormStatuses(status);
      let data = response.data;

      switch (response.status) {
        case 1:
          yield put({ type: GeneralActionTypes.Form_Statuses_Success, data });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Form_Statuses_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get form statuses: ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Page_Name_Request, function*(pageName) {
    //call server
    try {
      let response = yield pagesApi.document(pageName.data);
      let data = response.data;

      if (data.pageText) data.pageText = data.pageText.replace(/&nbsp;/gi, "");

      switch (response.status) {
        case 1:
          yield put({ type: GeneralActionTypes.Page_Name_Success, data });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Page_Name_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get page: ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Web_Files_Request, function*() {
    //call server
    try {
      let response = yield generalApi.GetWebFiles({ id: 0 });
      let data = response.data;

      switch (response.status) {
        case 1:
          yield put({ type: GeneralActionTypes.Web_Files_Success, data });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Web_Files_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get web files: ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Web_File_Request, function*(webFile) {
    //call server
    try {
      let response = yield generalApi.GetWebFile(webFile.data);

      if (response) {
        let file = response.data.fileContents;
        let fileName = response.data.fileDownloadName;
        let binary = atob(file.replace(/\s/g, ""));
        let view = new Uint8Array(file.length);
        for (var i = 0; i < file.length; i++) {
          view[i] = binary.charCodeAt(i);
        }
        let blob = new Blob([view], { type: "application/pdf" });
        let url = URL.createObjectURL(blob);
        yield put({
          type: GeneralActionTypes.Web_File_Response,
          url,
          fileName,
        });
      }
    } catch (error) {
      window.log("client =>> could not get web file: ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Bets_By_Bet_Code_Request, function*({
    request,
  }) {
    //call server
    try {
      let response = yield generalApi.BetsByBetCode(request);
      let data = response.data;
      let fieldsrequest = [];
      let selectedItems = [];
      let uniqueId = [];
      if (data && data.length > 0) {
        data.map((item) => {
          selectedItems.push({
            feed: { feedId: item.feedId },
            sport: { sportId: item.sportId },
            eventId: item.eventId,
            betType: { betTypeId: item.betTypeId },
            oddSpecialField: item.oddSpecialField,
            activeOddFieldId: item.activeOddFieldId,
            id: `${item["feedId"]}_${item["sportId"]}_${item["tournamentId"]}_${item["oddId"]}_${item["oddFieldNumber"]}_${item["betTypeId"]}`,
            selectedBonuses: item.selectedBonuses,
            selectedNumbers: item.selectedNumbers,
          });

          if (
            !uniqueId.includes(
              `${item["feedId"]}_${item["sportId"]}_${item["eventId"]}_${item["oddId"]}_${item["oddFieldNumber"]}_${item["betTypeId"]}`
            )
          ) {
            fieldsrequest.push({
              feed: { feedId: item.feedId },
              sport: { sportId: item.sportId },
              eventId: item.eventId,
              betType: { betTypeId: item.betTypeId },
              oddSpecialField: item.oddSpecialField,
              activeOddFieldId: item.activeOddFieldId,
              id: `${item["feedId"]}_${item["sportId"]}_${item["eventId"]}_${item["oddId"]}_${item["oddFieldNumber"]}_${item["betTypeId"]}`,
            });
            uniqueId.push(
              `${item["feedId"]}_${item["sportId"]}_${item["eventId"]}_${item["oddId"]}_${item["oddFieldNumber"]}_${item["betTypeId"]}`
            );
          }
        });
      }

      // this is for saving the selected items in betslip
      localStorage.setItem("fieldsrequest", JSON.stringify(selectedItems));
      //
      if (fieldsrequest && fieldsrequest.length > 0) {
        fieldsrequest = fieldsrequest.map((item) => {
          return {
            feed: item.feed,
            sport: item.sport,
            eventId: item.eventId,
            betType: item.betType,
            oddSpecialField: item.oddSpecialField,
            activeOddFieldId: item.activeOddFieldId,
          };
        });
      }

      switch (response.status) {
        case 1:
          yield put({ type: BetSlipActionTypes.BetSlip_Clear });
          yield put({
            type: GeneralActionTypes.Create_Bet_Code_Success,
            code: request.id,
          });
          yield put({ type: GeneralActionTypes.Bets_By_Bet_Code_Success });
          SessionStorage.betCode = request.id;

          if (fieldsrequest && fieldsrequest.length > 0) {
            yield put({
              type: SignalRTypes.Get_Updated_OddField_Details,
              request: fieldsrequest,
            });
          }
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Bets_By_Bet_Code_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get bet: ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Create_Bet_Code_Request, function*() {
    //call server
    try {
      const { betSlip } = yield select();
      let list = [];
      // console.log("betSlip.betSlipList",betSlip.betSlipList);
      // console.log("SessionStorage.betSlip",SessionStorage.betSlip);
      Object.keys(SessionStorage.betSlip).map((item) => {
        console.log("betSlip.betSlipList==", betSlip.betSlipList);
        SessionStorage.betSlip[item].selectedDraws &&
          SessionStorage.betSlip[item].selectedDraws.length > 0 &&
          SessionStorage.betSlip[item].selectedDraws.map((ele) =>
            list.push({
              feedId: SessionStorage.betSlip[item].feed.feedId,
              sportId: SessionStorage.betSlip[item].sport.sportId,
              eventId: ele.eventId,
              oddId: SessionStorage.betSlip[item].oddId,
              oddFieldNumber: SessionStorage.betSlip[item].oddFieldNumber,
              betLineNo: ele.eventBetLineNo,
              betTypeId: SessionStorage.betSlip[item].betType.betTypeId,
              selectedNumbers: SessionStorage.betSlip[item].selectedNumbers,
              selectedBonuses: SessionStorage.betSlip[item].selectedBonuses,
            })
          );
        list.push({
          feedId: SessionStorage.betSlip[item].feed.feedId,
          sportId: SessionStorage.betSlip[item].sport.sportId,
          eventId: SessionStorage.betSlip[item].eventId,
          oddId: SessionStorage.betSlip[item].oddId,
          oddFieldNumber: SessionStorage.betSlip[item].oddFieldNumber,
          betLineNo: SessionStorage.betSlip[item].eventBetLineNo,
          betTypeId: SessionStorage.betSlip[item].betType.betTypeId,
          selectedNumbers: SessionStorage.betSlip[item].selectedNumbers,
          selectedBonuses: SessionStorage.betSlip[item].selectedBonuses,
        });
      });
      console.log("listttt==", list);

      let data = {
        betLines: list,
      };
      let response = yield generalApi.CreateBetCode(data);

      switch (response.status) {
        case 1:
          yield put({
            type: GeneralActionTypes.Create_Bet_Code_Success,
            code: response.data.code,
          });
          SessionStorage.betCode = response.data.code;
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Create_Bet_Code_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not create bet code: ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Validate_Coupon_Request, function*({
    couponCode,
  }) {
    //call server
    try {
      const { general, auth } = yield select();
      let response = auth.signedIn
        ? yield membersApi.validateCoupon(couponCode)
        : yield generalApi.validateCoupon(couponCode);
      const { betSlipConstants } = general;
      SessionStorage.couponCode = couponCode.couponCode;

      switch (response.status) {
        case 1:
          if (response.data) {
            if (auth.signedIn) {
              let validateCouponResponse = yield membersApi.CouponConfirmByCouponCode(
                couponCode
              );
              if (
                validateCouponResponse.data &&
                validateCouponResponse.data.slotsGamesCategories
              ) {
                // noting for now
                yield put({
                  type: SlotsActionTypes.Set_Slots_Bonus_Games,
                  slotsBonusGamesCategories:
                    validateCouponResponse.data.slotsGamesCategories,
                  slotsBonusGames: validateCouponResponse.data.slotsBonusGames,
                });
                Utils.navigateTo(`/slotBonusGames`);
              } else {
                yield put({
                  type:
                    MembersActionTypes.Get_Sign_In_Loyalty_Rewards_Options_Request,
                });
              }
            }
            let userDate = Cookies.get("user");
            if (userDate != null && userDate.balance) {
              let couponCurrency = Object.values(userDate.balance).find(
                (item) => item.currencyId == response.data.currencyId
              );
              Cookies.set("selectedCurrency", couponCurrency);
              // yield put({ type: MembersActionTypes.Set_Selected_Currency, currency: couponCurrency })
            } else {
              let couponCurrency = Object.values(general.currencies).find(
                (item) => item.currencyId == response.data.currencyId
              );
              Cookies.set("selectedCurrency", couponCurrency);
              // yield put({ type: MembersActionTypes.Set_Selected_Currency, currency: couponCurrency })
            }

            //yield put({ type: MembersActionTypes.Set_Selected_Currency, currency: couponCurrency })
            // if (response.data.couponAmount)
            // {
            // 	yield put({ type: BetSlipActionTypes.On_Amount_Change, amount: response.data.couponAmount })

            // }
            yield put({
              type: GeneralActionTypes.Validate_Coupon_Success,
              data: response.data,
              message: response.message,
              couponName: response.data && response.data.couponName,
            });
          }

          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Validate_Coupon_Error,
            message: response.message,
          });
          break;
        default:
          break;
      }
    } catch (error) {
      window.log("client =>> could not validate coupon: ", error);
    }
  });

  yield takeLatest(
    GeneralActionTypes.Get_Loyalty_Rewards_Options_Request,
    function*() {
      //call server
      try {
        let response = yield generalApi.GetLoyaltyRewardsOptions();
        switch (response.status) {
          case 1:
            yield put({
              type: GeneralActionTypes.Get_Loyalty_Rewards_Options_Success,
              loyalityRewardOptions: response.data.loyaltyRewardsOptions,
            });
            break;
          case 3 || 4:
            yield put({
              type: GeneralActionTypes.Get_Loyalty_Rewards_Options_Error,
              loyalityRewardOptionsError: response.message,
            });
            break;
          default:
        }
      } catch (error) {
        window.log("client =>> could not validate coupon: ", error);
      }
    }
  );
  yield takeLatest(GeneralActionTypes.Get_Sport_Promos_Request, function*() {
    //call server
    try {
      let response = yield generalApi.GetSportPromos();
      switch (response.status) {
        case 1:
          yield put({
            type: GeneralActionTypes.Get_Sport_Promos_Suceess,
            promosList: response.data,
          });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Sport_Promos_Error,
            promosError: response.message,
          });
          break;
        default:
      }
    } catch (error) {
      window.log("client =>> Error in GetSportPromos: ", error);
    }
  });
  yield takeLatest(GeneralActionTypes.Get_Sport_Promos_Info_Request, function*({
    data,
  }) {
    //call server
    try {
      let response = yield generalApi.GetSportPromoInfo(data);
      switch (response.status) {
        case 1:
          yield put({
            type: GeneralActionTypes.Get_Sport_Promos_Info_Suceess,
            singlePromoInfo: response.data,
          });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Sport_Promos_Info_Error,
            promoInfoError: response.message,
          });
          break;
        default:
      }
    } catch (error) {
      window.log("client =>> Error in GetSportPromoInfo: ", error);
    }
  });
  yield takeLatest(GeneralActionTypes.Get_Header_Tabs_Request, function*() {
    //call server
    try {
      let response = yield generalApi.GetHeaderTabs();
      const { signalr } = yield select();

      const activeTabs =
        response.data &&
        response.data.headerTabs &&
        response.data.headerTabs.map((item) => item.headerTabsName);
      switch (response.status) {
        case 1:
          if (
            !activeTabs.includes("Spin & Win") &&
            !activeTabs.includes("Winners Spin & Win")
          ) {
            window.log("disconnect spin and win requst");
            yield put({ type: SignalRTypes.SpinAndWin_Disconnect_Request });
          }
          if (!activeTabs.includes("Lucky Numbers")) {
            yield put({ type: SignalRTypes.LuckyNumbers_Disconnect_Request });
          }

          yield put({
            type: GeneralActionTypes.Get_Header_Tabs_Success,
            headerTabs: activeTabs,
          });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Header_Tabs_Error,
            headerTabsError: response.message,
          });
          break;
        default:
      }
    } catch (error) {
      window.log("client =>> Error in Getting header tabs: ", error);
    }
  });
  yield takeLatest(
    GeneralActionTypes.Get_Lucky_Number_Configuration_Request,
    function*() {
      //call server
      try {
        let response = yield generalApi.GetLuckyNumberConfiguration();
        const data = response.data;
        const howToPlayText = data && data.howToPlayText;
        const luckyNumberFooters = data && data.luckyNumberFooters;
        const luckyNumberHomePageTexts = data && data.luckyNumberHomePageTexts;
        const luckyNumberTabs = data && data.luckyNumberTabs;
        const luckyNumberUpcomintDraws = data && data.luckyNumberUpcomintDraws;
        const luckyNumberUpcomingDrawsPageTexts =
          data && data.luckyNumberUpcomingDrawsPageTexts;
        const luckyNumberResultsPageTexts =
          data && data.luckyNumberResultsPageTexts;
        switch (response.status) {
          case 1:
            yield put({
              type: GeneralActionTypes.Get_Lucky_Number_Configuration_Success,
              luckyNumberConfigration: response.data,
              howToPlayText: howToPlayText,
              luckyNumberFooters: luckyNumberFooters,
              luckyNumberHomePageTexts: luckyNumberHomePageTexts,
              luckyNumberTabs: luckyNumberTabs,
              luckyNumberUpcomintDraws: luckyNumberUpcomintDraws,
              luckyNumberUpcomingDrawsPageTexts: luckyNumberUpcomingDrawsPageTexts,
              luckyNumberResultsPageTexts: luckyNumberResultsPageTexts,
            });
            break;
          case 3 || 4:
            yield put({
              type: GeneralActionTypes.Get_Lucky_Number_Configuration_Error,
              error: response.message,
            });
            break;
          default:
        }
      } catch (error) {
        window.log("client =>> Error in Lucky Numbers Configration: ", error);
      }
    }
  );
  yield takeLatest(
    GeneralActionTypes.Get_Landing_Configuration_Request,
    function*() {
      //call server
      try {
        let response = yield generalApi.GetLandingConfiguration();
        const data = response.data;
        switch (response.status) {
          case 1:
            let banners = data.banners;
            let promos = data.promos;
            let slotsGame = data.slotsGame;
            let bettingImagePath = `${data.bettingImagePath}?id=${data.imageVersion}`;
            let sections = data.tabs;
            yield put({
              type: GeneralActionTypes.Get_Landing_Configuration_Success,
              banners,
              promos,
              slotsGame,
              bettingImagePath,
              sections,
            });
            break;
          case 3 || 4:
            yield put({
              type: GeneralActionTypes.Get_Landing_Configuration_Error,
              error: response.message,
            });
            break;
          default:
        }
      } catch (error) {
        window.log("client =>> Error in Getting Landing Configration: ", error);
      }
    }
  );

  yield takeLatest(
    GeneralActionTypes.Get_Work_With_Us_Configuration_Request,
    function*() {
      //call server
      try {
        let response = yield generalApi.GetWorkWithUsConfiguration();
        const data = response.data;
        switch (response.status) {
          case 1:
            let workWithUsBanner = `${data.bannerImagePath}?id=${data.imageVersion}`;
            let workWithUsMobileBanner = `${data.mobileBannerImagePath}?id=${data.imageVersion}`;
            let workWithUsSections = data.workWithUsPages;
            yield put({
              type: GeneralActionTypes.Get_Work_With_Us_Configuration_Success,
              workWithUsBanner,
              workWithUsSections,
              workWithUsMobileBanner,
            });
            break;
          case 3 || 4:
            yield put({
              type: GeneralActionTypes.Get_Work_With_Us_Configuration_Error,
              error: response.message,
            });
            break;
          default:
        }
      } catch (error) {
        window.log(
          "client =>> Error in Getting Work With Us Configration ",
          error
        );
      }
    }
  );
  yield takeLatest(
    GeneralActionTypes.Get_Kiosk_Web_Banner_Images_Request,
    function*({ GroupId }) {
      //call server
      try {
        let response = yield generalApi.GetKioskWebBannerImages(GroupId);
        const data = response.data;
        switch (response.status) {
          case 1:
            yield put({
              type: GeneralActionTypes.Get_Kiosk_Web_Banner_Images_Success,
              kioskBanners: data.kioskBannerImages,
              bannerGroupId: data.bannerGroupId,
            });
            break;
          case 3 || 4:
            yield put({
              type: GeneralActionTypes.Get_Kiosk_Web_Banner_Images_Error,
              error: response.message,
            });
            break;
          default:
        }
      } catch (error) {
        window.log("client =>> Error in Getting KioskWebBannerImages", error);
      }
    }
  );

  yield takeLatest(
    GeneralActionTypes.Get_DrillDown_Groups_Request,
    function*() {
      //call server
      try {
        let response = yield generalApi.getBetTypesDrillDownGroups();

        switch (response.status) {
          case 1:
            yield put({
              type: GeneralActionTypes.Get_DrillDown_Groups_Success,
              data: response.data,
            });
            break;
          case 3 || 4:
            yield put({
              type: GeneralActionTypes.Get_DrillDown_Groups_Error,
              message: response.message,
            });
            break;
        }
      } catch (error) {
        window.log(
          "client =>> could not get BetTypes DrillDown Groups: ",
          error
        );
      }
    }
  );
  yield takeLatest(GeneralActionTypes.Get_Configuration_Request, function*() {
    //call server
    const searchParams = new URLSearchParams(window.location.search);
    const source = searchParams.get("s") || null; // Optional param 's'
    const campaign = searchParams.get("c") || null; // Optional param 'c'

    try {
      let data = {
        deviceToken: localStorage.getItem("firebaseDeviceToken"),
        source,
        campaign,
      };

      let response = yield generalApi.getConfiguration(data);

      switch (response.status) {
        case 1:
          const configrationImages =
            response.data && response.data.configurationImages;
          const configrationInfo =
            configrationImages && configrationImages.length > 0
              ? {
                  ...response.data,
                  androidImage: `${
                    response.data.androidImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "androidImage"
                  )}`,
                  appleImage: `${
                    response.data.appleImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "appleImage"
                  )}`,
                  freeSpinBackGroundImagePath: `${
                    response.data.freeSpinBackGroundImagePath
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "freeSpinBackGroundImagePath"
                  )}`,
                  freeSpinButtonImagePath: `${
                    response.data.freeSpinButtonImagePath
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "freeSpinButtonImagePath"
                  )}`,
                  landingImage: `${
                    response.data.landingImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "landingImage"
                  )}`,
                  lonestarImage: `${
                    response.data.lonestarImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "lonestarImage"
                  )}`,
                  voucherImage: `${
                    response.data.voucherImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "voucherImage"
                  )}`,
                  tipMeImage: `${
                    response.data.tipMeImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "tipMeImage"
                  )}`,
                  jackpotImage: `${
                    response.data.jackpotImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "jackpotImage"
                  )}`,
                  freeSpinCirculeBorderImagePath: `${
                    response.data.freeSpinCirculeBorderImagePath
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "freeSpinCirculeBorderImagePath"
                  )}`,
                  eighteenPlusImage: `${
                    response.data.eighteenPlusImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "eighteenPlusImage"
                  )}`,
                  statisticImage: `${
                    response.data.statisticImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "statisticImage"
                  )}`,
                  mainTournamentImage: `${
                    response.data.mainTournamentImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "mainTournamentImage"
                  )}`,
                  luckyNumberWebsiteBannerPath: `${
                    response.data.luckyNumberWebsiteBannerPath
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "luckyNumberWebsiteBannerPath"
                  )}`,
                  luckyNumberMobileBannerPath: `${
                    response.data.luckyNumberMobileBannerPath
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "luckyNumberMobileBannerPath"
                  )}`,
                  cancelledDrawImage: `${
                    response.data.cancelledDrawImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "cancelledDrawImage"
                  )}`,
                  promotionImage: `${
                    response.data.promotionImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "promotionImage"
                  )}`,
                  orangeImage: `${
                    response.data.orangeImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "orangeImage"
                  )}`,
                  newIconImage: `${
                    response.data.newIconImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "newIconImage"
                  )}`,
                  fixtureImage: `${
                    response.data.fixtureImage
                  }${getGeneralImagesVersions(
                    configrationImages,
                    "fixtureImage"
                  )}`,
                }
              : response.data;
          yield put({
            type: GeneralActionTypes.Get_Configuration_Success,
            data: configrationInfo,
          });
          Cookies.set(
            "tokenExpiresMinutes",
            response.data.tokenExpiresMinutes,
            response.data.tokenExpiresMinutes
          );

          if (AppConfig.ENV != Env.LOCAL) {
            AppConfig.srAddress = response.data.feedSR;
            AppConfig.booongoSRAddress = response.data.booongoSR;
            AppConfig.jackpotSRAddress = response.data.jackpotSR;
            AppConfig.memberChangeSRAddress = response.data.memberChangeSR;
            AppConfig.ShowSignInAndRegistersBtn =
              response.data.showSignInAndRegistersBtn === 1 ? true : false;
            AppConfig.virtualFeedSR = response.data.virtualFeedSR;
            AppConfig.spinAndWinFeedSR = response.data.spinAndWinFeedSR;
            AppConfig.luckyNumbersFeedSR = response.data.luckyNumberFeedSR;
            AppConfig.staticFeedSR = response.data.staticFeedSR;
            AppConfig.liveFeedSR = response.data.liveFeedSR;
          }
          AppConfig.booongoAddress = response.data.booongoAddress;
          AppConfig.VirtualAddress.VFL = response.data.vfl; //Not in used
          AppConfig.VirtualAddress.VHC = response.data.vhc; //Not in used
          AppConfig.VirtualAddress.VFLM = response.data.vflm;
          AppConfig.VirtualAddress.VBL = response.data.vbl;
          AppConfig.VirtualAddress.VTO = response.data.vto; //Not in used
          AppConfig.VirtualAddress.VDR = response.data.vdr; //Not in used
          AppConfig.VirtualAddress.EPL = response.data.epl;
          AppConfig.icons = `${response.data.imagesPath}icons/`;
          AppConfig.symbols = `${response.data.imagesPath}symbols/`;
          AppConfig.teamsIconPath = response.data.teamsIconPath;
          AppConfig.countryFlagImagesPath = response.data.countryFlagImagesPath;
          AppConfig.StatisticsAddress.Domain =
            response.data.statisticsDomainUrl;
          AppConfig.StatisticsAddress.Static =
            response.data.statisticsStaticUrl;
          AppConfig.StatisticsAddress.Virtual =
            response.data.statisticsVirtualUrl;
          AppConfig.StatisticsAddress.Menu = response.data.statisticsMenuUrl;
          AppConfig.bannerSR = response.data.bannerSR;
          AppConfig.headerTabs = response.data.headerTabs;
          localStorage.setItem(
            "headerTabs",
            JSON.stringify(response.data.headerTabs)
          );

          AppConfig.JackpotSRTimeout = response.data.jackpotSRTimeout;

          yield put({ type: AppActionTypes.Start });

          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Configuration_Error,
            message: response.message,
          });
          break;
        default:
          break;
      }
    } catch (error) {
      window.log("client =>> could not get BetTypes DrillDown Groups: ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Bet_Code_Clear, function*() {
    //call server
    try {
      yield put({ type: GeneralActionTypes.Create_Bet_Code_Success, code: "" });
      SessionStorage.betCode = "";
    } catch (error) {
      window.log("client =>> could not create bet code: ", error);
    }
  });

  yield takeLatest(
    GeneralActionTypes.Get_CountryPhone_Providers_Request,
    function*({ data }) {
      //call server
      try {
        let response = yield generalApi.getCountryPhoneProviders(data);
        switch (response.status) {
          case 1:
            let prefixes = response.data.map(
              (provider) => provider.providerPrefix
            );
            yield put({
              type: GeneralActionTypes.Get_CountryPhone_Providers_Success,
              prefixes: prefixes,
            });
            break;
          case 3 || 4:
            yield put({
              type: GeneralActionTypes.Get_CountryPhone_Providers_Error,
              message: response.message,
            });
            break;
        }
      } catch (error) {
        window.log("client =>> could not get country provides ", error);
      }
    }
  );

  yield takeLatest(GeneralActionTypes.Get_Countries_Request, function*() {
    //call server
    try {
      let response = yield generalApi.getCountries();
      switch (response.status) {
        case 1:
          yield put({
            type: GeneralActionTypes.Get_Countries_Success,
            countries: response.data,
          });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Countries_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get countries ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Get_Banners_Request, function*() {
    //call server
    try {
      let response = yield generalApi.getBanners();
      switch (response.status) {
        case 1:
          yield put({
            type: GeneralActionTypes.Get_Banners_Success,
            promotionalBanners: response.data,
          });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Banners_Error,
            promotionalBannersError: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get Banners ", error);
    }
  });
  yield takeLatest(GeneralActionTypes.Get_Calender_Request, function*() {
    //call server
    try {
      let response = yield generalApi.getCalenderIcons();
      switch (response.status) {
        case 1:
          yield put({
            type: GeneralActionTypes.Get_Calender_Success,
            calenderImages: response.data,
          });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Calender_Error,
            calenderImagesError: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get Banners ", error);
    }
  });

  yield takeLatest(
    GeneralActionTypes.Get_Footer_Providers_Request,
    function*() {
      //call server
      try {
        let response = yield generalApi.getFooterProvider();

        switch (response.status) {
          case 1:
            yield put({
              type: GeneralActionTypes.Get_Footer_Providers_Success,
              footerProviders: response.data,
            });
            break;
          case 3 || 4:
            yield put({
              type: GeneralActionTypes.Get_Footer_Providers_Error,
              footerProvidersError: response.message,
            });
            break;
        }
      } catch (error) {
        window.log("client =>> could not get Banners ", error);
      }
    }
  );

  yield takeLatest(GeneralActionTypes.Get_Footer_Text_Request, function*() {
    //call server
    try {
      let response = yield pagesApi.getFooterText();

      switch (response.status) {
        case 1:
          yield put({
            type: GeneralActionTypes.Get_Footer_Text_Success,
            footerText: response.data,
          });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Footer_Text_Error,
            footerTextError: response.message,
          });
          break;
        default:
          break;
      }
    } catch (error) {
      window.log("client =>> could not get Banners ", error);
    }
  });

  yield takeLatest(GeneralActionTypes.Get_Country_Flag_Images, function*() {
    //call server
    try {
      let response = yield generalApi.getCountryFlags();

      switch (response.status) {
        case 1:
          yield put({
            type: GeneralActionTypes.Get_Country_Flag_Images_Success,
            countryFlags: response.data.countryFlagImages,
          });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Country_Flag_Images_Error,
            countryFlagsError: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get Banners ", error);
    }
  });

  yield takeLatest(
    GeneralActionTypes.Get_Sport_Types_Icons_Request,
    function*() {
      //call server
      try {
        let response = yield generalApi.getSportTypesIcons();

        switch (response.status) {
          case 1:
            yield put({
              type: GeneralActionTypes.Get_Sport_Types_Icons_Success,
              sportTypesIcons: response.data.sportTypesIcons,
            });
            break;
          case 3 || 4:
            yield put({
              type: GeneralActionTypes.Get_Sport_Types_Icons_Error,
              sportTypesIconsError: response.message,
            });
            break;
        }
      } catch (error) {
        window.log("client =>> could not get sport type icon ", error);
      }
    }
  );

  yield takeLatest(GeneralActionTypes.Get_Counties_Request, function*() {
    //call server
    try {
      let response = yield generalApi.getCounties();
      switch (response.status) {
        case 1:
          yield put({
            type: GeneralActionTypes.Get_Counties_Success,
            counties: response.data,
          });
          break;
        case 3 || 4:
          yield put({
            type: GeneralActionTypes.Get_Counties_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client =>> could not get counties ", error);
    }
  });
}

export default function* GeneralSaga() {
  yield all([fork(requests)]);
}
